import { Notification } from './types';

export const notifications: Notification[] = [
    {
        id: '1',
        title: 'Pembayaran SPP Diterima',
        message: 'Pembayaran SPP bulan Februari oleh Ahmad (SD) telah diterima.',
        time: '5 menit yang lalu',
        type: 'success',
        read: false,
    },
    {
        id: '2',
        title: 'Pengajuan Anggaran Baru',
        message: 'Unit SMP mengajukan anggaran baru untuk kegiatan ekstrakurikuler.',
        time: '1 jam yang lalu',
        type: 'info',
        read: false,
    },
    {
        id: '3',
        title: 'Peringatan Saldo Rendah',
        message: 'Saldo operasional Unit TK mendekati batas minimum.',
        time: '3 jam yang lalu',
        type: 'warning',
        read: true,
    },
    {
        id: '4',
        title: 'Laporan Bulan Januari',
        message: 'Laporan keuangan bulan Januari telah tersedia untuk diunduh.',
        time: '1 hari yang lalu',
        type: 'info',
        read: true,
    },
    {
        id: '5',
        title: 'Kesalahan Sinkronisasi',
        message: 'Gagal menyinkronkan data bank pada Unit SMA. Harap periksa koneksi.',
        time: '2 hari yang lalu',
        type: 'error',
        read: true,
    },
];
